'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _objectSpread = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

var EventEmitter = require('events');

var debug = require('debug');

var log = debug('libp2p:webrtc-star:listener');
log.error = debug('libp2p:webrtc-star:listener:error');

var multiaddr = require('multiaddr');

var io = require('socket.io-client');

var SimplePeer = require('simple-peer');

var pDefer = require('p-defer');

var toConnection = require('./socket-to-conn');

var _require = require('./utils'),
    cleanUrlSIO = _require.cleanUrlSIO;

var _require2 = require('./constants'),
    CODE_P2P = _require2.CODE_P2P;

var sioOptions = {
  transports: ['websocket'],
  'force new connection': true
};

module.exports = function (_ref, WebRTCStar) {
  var handler = _ref.handler,
      upgrader = _ref.upgrader;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var listener = new EventEmitter();
  var listeningAddr;
  listener.__connections = [];

  listener.listen = function (ma) {
    var defer = pDefer();
    listeningAddr = ma;

    if (!ma.protoCodes().includes(CODE_P2P) && upgrader.localPeer) {
      WebRTCStar._signallingAddr = ma.encapsulate("/p2p/".concat(upgrader.localPeer.toB58String()));
    } else {
      WebRTCStar._signallingAddr = ma;
    }

    var sioUrl = cleanUrlSIO(ma);
    log('Dialing to Signalling Server on: ' + sioUrl);
    listener.io = io.connect(sioUrl, sioOptions);

    var incommingDial = function incommingDial(offer) {
      if (offer.answer || offer.err) {
        return;
      }

      var spOptions = _objectSpread({
        trickle: false
      }, options); // Use custom WebRTC implementation


      if (WebRTCStar.wrtc) {
        spOptions.wrtc = WebRTCStar.wrtc;
      }

      var channel = new SimplePeer(spOptions);

      var onError = function onError(err) {
        log.error('incoming connectioned errored', err);
      };

      channel.on('error', onError);
      channel.once('close', function () {
        channel.removeListener('error', onError);
      });
      channel.once('signal', function (signal) {
        offer.signal = signal;
        offer.answer = true;
        listener.io.emit('ss-handshake', offer);
      });
      channel.signal(offer.signal);
      channel.once('connect', /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var maConn, conn;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                maConn = toConnection(channel);
                log('new inbound connection %s', maConn.remoteAddr);
                _context.prev = 2;
                _context.next = 5;
                return upgrader.upgradeInbound(maConn);

              case 5:
                conn = _context.sent;
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](2);
                log.error('inbound connection failed to upgrade', _context.t0);
                return _context.abrupt("return", maConn.close());

              case 12:
                if (!conn.remoteAddr) {
                  try {
                    conn.remoteAddr = ma.decapsulateCode(CODE_P2P).encapsulate("/p2p/".concat(conn.remotePeer.toB58String()));
                  } catch (err) {
                    log.error('could not determine remote address', err);
                  }
                }

                log('inbound connection %s upgraded', maConn.remoteAddr);
                trackConn(listener, maConn);
                listener.emit('connection', conn);
                handler(conn);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[2, 8]]);
      })));
    };

    listener.io.once('connect_error', function (err) {
      return defer.reject(err);
    });
    listener.io.once('error', function (err) {
      listener.emit('error', err);
      listener.emit('close');
    });
    listener.io.on('ws-handshake', incommingDial);
    listener.io.on('ws-peer', WebRTCStar._peerDiscovered);
    listener.io.on('connect', function () {
      listener.io.emit('ss-join', WebRTCStar._signallingAddr.toString());
    });
    listener.io.once('connect', function () {
      listener.emit('listening');
      defer.resolve();
    });
    return defer.promise;
  };

  listener.close = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            listener.io && listener.io.emit('ss-leave');
            _context2.next = 3;
            return Promise.all(listener.__connections.map(function (maConn) {
              return maConn.close();
            }));

          case 3:
            listener.emit('close');

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  listener.getAddrs = function () {
    return [listeningAddr];
  };

  WebRTCStar.listenersRefs[multiaddr.toString()] = listener;
  return listener;
};

function trackConn(listener, maConn) {
  listener.__connections.push(maConn);

  var untrackConn = function untrackConn() {
    listener.__connections = listener.__connections.filter(function (c) {
      return c !== maConn;
    });
  };

  maConn.conn.once('close', untrackConn);
}